import useGetCompletedQuests from '~/components/QuestPanel/hooks/useGetCompletedQuests'
import { BadgeData, SubBadges } from '~/components/QuestPanel/type'
import { CHAMPIONSHIP_IDS, QUIZ_SUBJECT } from '~/types/homebaseQuiz.types'
import { useGetBadgesQuery } from '~/redux/apis/collection-api'

// Exactly what `Collection` draws. Completed quests outside this list — the advanced quizzes, say — have no
// trophy on the page, so they must not open the door to it.
const SHOWN_TROPHY_IDS: string[] = [...Object.values(QUIZ_SUBJECT), ...Object.values(CHAMPIONSHIP_IDS)]

/**
 * Whether the user has earned any of the retired rewards — bootcamp super-badges, math-drill
 * trophies, the 2021 championship. The league badge is current, not legacy, so it does not count.
 *
 * Both sources arrive after the first paint (the quests come from Firestore), so `isLoading` stays
 * true until they do: the entry point must appear once, not appear and then vanish.
 */
export default function useHasLegacyAchievements(): { hasAny: boolean; isLoading: boolean } {
  const { data: badges, isLoading: isLoadingBadges } = useGetBadgesQuery(null)
  const completedQuests = useGetCompletedQuests()

  const hasBadge = (badges ?? []).some((badge: BadgeData) =>
    badge.subBadges?.some((subBadge: SubBadges) => subBadge.isComplete),
  )
  const hasTrophy = (completedQuests ?? []).some((quest) => SHOWN_TROPHY_IDS.includes(quest.id))

  return {
    hasAny: hasBadge || hasTrophy,
    isLoading: isLoadingBadges || completedQuests === undefined,
  }
}
